import React from "react";
import Parser from "html-react-parser";
import { sweetalert } from "../App";

export interface ConfirmationState {
    linkedApptsID: string
    code: string
    services: string
    htmlTemplates:any
}

class Confirmation extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {htmlTemplates: []}
        this.redirectToPortal = this.redirectToPortal.bind(this);
    }

    async componentDidMount() {
        const query = new URLSearchParams(window.location.search)   

        this.setState({linkedApptsID: query.get('apptCode'), code: query.get('code'), services: query.get('services') }, ()=>{
            fetch("/api/system/confirmationTemplate?services=" + this.state.services)
                .then(res => res.json() )
                .then( data => {
                    this.setState({ htmlTemplates: data})
                })
                .catch((err)=>{console.error(err);})
        });
    }

    redirectToPortal = ()=>{
        sweetalert.fire({
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: 'Continue',
            title: 'Attention',
            html: "<p>You will be redirected to Streamline Patient Portal.</p>",
            icon:'info'
        }).then((result)=>{
            if(result.isConfirmed){
                //TODO: after testing this needs to be a PRODUCTION url
                window.open("https://dev.portal.immytech.com/register", "_blank");
            }
        });
    }

    render(): React.ReactElement | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        let code = this.state.code ? this.state.code : ''
        code = code.split(",")
        return(
            <React.Fragment>
                <div className="container-fluid  min-vh-100 ">
                    <div className={"row"}>
                        <div className="col-12 col-sm-12  col-md-12 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 pt-2">
                            <div className="card mb-2">
                                <div className="card-header verlag-bold">
                                    <h4>Appointment# {this.state.linkedApptsID}</h4>
                                </div>
                                <div className="card-body">
                                    <div>
                                    {/* <h1 className={"verlag-bold"}>{this.state.services?.length > 1 ? 'Your codes' : 'Your code'}: {code}</h1><hr /> */}

                                    <p><b>Please save</b> a copy of this information for your records. <b>You are required to bring
                                        this appointment code and any confirmation codes to your appointment.</b></p>
                                    </div>
                                    <hr />
                                    

                                    {this.state.htmlTemplates.map((t, i) => {
                                        return (
                                        <>
                                        <div className={"p-2 mb-2"} style={{borderWidth: '1px', borderColor: 'lightgray', borderStyle: 'solid', borderRadius: 15}}>
                                            <div className="row">
                                                <div className={"col-12 col-md-8 mb-2 mb-md-0"}>
                                                    <h4 className="verlag-bold">{t.Name}</h4>
                                                </div>   
                                                <div className={"col-12 col-md-4 mb-2 mb-md-0 text-md-right"}>
                                                    <h4>Conf# {code[i]}</h4>
                                                </div>       
                                            </div>
                                            <div className={"row"}>
                                                <div className="col-12">
                                                {t.HTMLTemplate && Parser(t.HTMLTemplate)}
                                                </div>
                                            </div>                                     
                                        </div>
                                        <h4 className="verlag-bold">Additional Information</h4>
                                        <div className="col-12">
                                            {t.AdditionalInformation && Parser(t.AdditionalInformation)}
                                        </div>
                                        </>      
                                        )
                                                
                                    })}

                                    {/* <div className="d-grid">
                                        <p>Access all of your results in one convenient location with Streamline Patient Portal.</p>
                                        <div className="d-flex justify-center">
                                            <button 
                                                className="btn btn-primary"
                                                onClick={this.redirectToPortal}> 
                                                    <img src="/images/FullLogoWhite.png" 
                                                        alt="streamlineLogo"
                                                        style={{ "width": "300px", "margin": "10px" }}
                                                    />
                                                    <br />Register Here
                                            </button>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Confirmation;